"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.STAFF_MEMBERS_SNAPSHOT_KEY = void 0;
exports.makeStaffMembersBridgeCriteria = makeStaffMembersBridgeCriteria;
exports.seedStaffMembersFilter = seedStaffMembersFilter;
exports.default = StaffMembersSearch;
const react_1 = __importStar(require("react"));
const react_router_dom_1 = require("react-router-dom");
const FilterableTable_1 = __importDefault(require("../../View/Resultsets/FilterableTable/FilterableTable"));
const StaffMemberModalButtons_1 = require("./Modals/StaffMemberModalButtons");
const UserModalButtons_1 = require("./Modals/UserModalButtons");
const StaffMembersController_1 = require("./StaffMembersController");
const StaffMemberFilterBody_1 = require("./StaffMemberFilterBody");
const adminTableCells_1 = require("../adminTableCells");
const MainSetupReact_1 = __importDefault(require("../../React/MainSetupReact"));
const FidmanUserSyncBadge_1 = require("./FidmanUserSyncBadge");
/** Nazwa roli systemowej po numerze - rola przychodzi z JOIN-a jako identyfikator. */
function roleNameById(systemRoleId) {
    if (systemRoleId === null || systemRoleId === undefined)
        return "-";
    const entry = Object.entries(MainSetupReact_1.default.SystemRoles).find(([, role]) => role.id === Number(systemRoleId));
    return entry ? entry[0] : String(systemRoleId);
}
/** Klucz, pod którym FilterableTable pamięta kryteria tego okna (patrz FilterPanel). */
exports.STAFF_MEMBERS_SNAPSHOT_KEY = "filtersableTableSnapshot_staffMembers";
function makeStaffMembersBridgeCriteria(params) {
    const phrase = (params.fraza ?? "").trim();
    if (!phrase)
        return null;
    // Rola i podmiot jawnie puste, gdy ich nie ma - zasiew nadpisuje migawkę w całości,
    // więc stare wartości i tak znikają; puste pola mówią o tym wprost.
    const criteria = { searchText: phrase, scope: "all", systemRoleId: "", _entities: [] };
    const roleId = Number(params.rola);
    if (params.rola && Number.isInteger(roleId) && roleId > 0)
        criteria.systemRoleId = String(roleId);
    const entityId = Number(params.podmiot);
    if (params.podmiot && Number.isInteger(entityId) && entityId > 0)
        criteria._entities = [{ id: entityId, name: params.podmiotNazwa ?? "" }];
    return criteria;
}
/**
 * Zasiew kryteriów PRZED zamontowaniem tabeli. Pierwotny pomost nakładał osobę na
 * ZAPAMIĘTANE wyszukiwanie (fraza „test” z poprzedniej wizyty + inna osoba = 0 wierszy,
 * owner to zobaczył), bo FilterPanel odtwarza kryteria z sessionStorage przy montowaniu.
 * Nadpisanie migawki w całości kasuje tamto wyszukiwanie i podstawia nowe, zanim panel
 * je odczyta. Zwraca true, gdy zasiew nastąpił.
 */
function seedStaffMembersFilter(params, storage = sessionStorage) {
    const criteria = makeStaffMembersBridgeCriteria(params);
    if (!criteria)
        return false;
    storage.setItem(exports.STAFF_MEMBERS_SNAPSHOT_KEY, JSON.stringify({ criteria }));
    return true;
}
/**
 * Konta i uprawnienia osób - jedyne okno do zarządzania użytkownikami (PER-3).
 *
 * Lista idzie OD osób, nie od tabeli uprawnień - osoba bez nadanych uprawnień też
 * musi być widoczna, inaczej nie dałoby się jej niczego nadać. Zakres wybiera się
 * w filtrze (D-PER-7): domyślnie osoby z nadanymi uprawnieniami, dalej „z kontem”
 * (e-mail systemowy albo uprawnienia), na końcu cała książka adresowa.
 *
 * Przycisk dodawania zakłada osobę RAZEM z kontem - przejął to po skasowanym ekranie
 * „Dodawanie użytkowników". Usuwania nie ma i mieć nie będzie: wiersz to człowiek,
 * a odejście z firmy to wyłączenie flagi „Aktywny", nie skasowanie wiersza. Osoby kasuje
 * się w oknie „Osoby".
 */
function StaffMembersSearch({ title }) {
    const [searchParams, setSearchParams] = (0, react_router_dom_1.useSearchParams)();
    const frazaParam = searchParams.get("fraza");
    const bridgeParams = {
        fraza: frazaParam,
        rola: searchParams.get("rola"),
        podmiot: searchParams.get("podmiot"),
        podmiotNazwa: searchParams.get("podmiotNazwa"),
    };
    // Zasiew w trakcie renderu, nie w efekcie: FilterPanel czyta migawkę przy montowaniu,
    // a efekty dzieci biegną przed efektami rodzica - zasiew w useEffect byłby za późno
    // i pierwsze wyszukanie poszłoby ze starymi kryteriami. Ref, żeby zasiać raz na montaż.
    const seeded = (0, react_1.useRef)(false);
    if (!seeded.current) {
        seeded.current = true;
        seedStaffMembersFilter(bridgeParams);
    }
    (0, react_1.useEffect)(() => {
        document.title = title;
    }, [title]);
    // Parametr zrobił swoje i znika z adresu, żeby odświeżenie strony nie wracało do
    // wskazanej osoby po raz drugi, a zakładka z gołym adresem działała jak zwykle.
    (0, react_1.useEffect)(() => {
        if (frazaParam !== null)
            setSearchParams({}, { replace: true });
    }, [frazaParam, setSearchParams]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(FilterableTable_1.default, { id: "staffMembers", title: title, FilterBodyComponent: StaffMemberFilterBody_1.StaffMembersFilterBody, tableStructure: [
                {
                    // Druga linia to e-mail SYSTEMOWY (logowanie), nie kontaktowy - to okno
                    // odpowiada na pytanie „co osoba może w systemie". Plakietka FIDmana
                    // i podmiot mieszkają w tej samej komórce: tabela trzyma 11 kolumn
                    // siatki, dwunasta jest menu akcji wiersza (lekcja packa PIS), więc
                    // bez nowych kolumn. Podmiot doszedł w PER-3 razem z filtrem podmiotu -
                    // bez niego nie dałoby się wzrokiem sprawdzić, co filtr wybrał.
                    header: "Osoba",
                    renderTdBody: (person) => (react_1.default.createElement(adminTableCells_1.Centered, null,
                        react_1.default.createElement("div", null,
                            person._personName,
                            " ",
                            person._personSurname,
                            react_1.default.createElement(FidmanUserSyncBadge_1.FidmanUserSyncBadge, { enabled: !!person._fidmanEnabled, sync: person._fidmanSync, className: "ms-2 align-middle" })),
                        react_1.default.createElement("div", { className: "text-muted small" }, person._systemEmail || react_1.default.createElement("span", { className: "fst-italic" }, "bez e-maila systemowego")),
                        person._entityName && react_1.default.createElement("div", { className: "text-muted small" }, person._entityName))),
                    colMd: 3,
                },
                {
                    header: "Rola",
                    renderTdBody: (person) => (react_1.default.createElement(adminTableCells_1.Centered, null,
                        react_1.default.createElement("span", { className: "small" }, roleNameById(person._systemRoleId)))),
                    colMd: 2,
                },
                {
                    header: "Kierowca",
                    renderTdBody: (person) => react_1.default.createElement(adminTableCells_1.BoolCell, { value: person.isDriver }),
                    colMd: 1,
                },
                {
                    header: "Scrum",
                    renderTdBody: (person) => react_1.default.createElement(adminTableCells_1.BoolCell, { value: person.isInScrum }),
                    colMd: 1,
                },
                {
                    header: "Faktury kosztowe",
                    renderTdBody: (person) => react_1.default.createElement(adminTableCells_1.BoolCell, { value: person.hasCostInvoiceAccess }),
                    colMd: 1,
                },
                {
                    header: "Bank",
                    renderTdBody: (person) => react_1.default.createElement(adminTableCells_1.BoolCell, { value: person.hasBankAccess }),
                    colMd: 1,
                },
                {
                    header: "Wizyty",
                    renderTdBody: (person) => react_1.default.createElement(adminTableCells_1.BoolCell, { value: person.canLogSiteVisits }),
                    colMd: 1,
                },
                {
                    header: "Aktywny",
                    renderTdBody: (person) => react_1.default.createElement(adminTableCells_1.BoolCell, { value: person.isActive }),
                    colMd: 1,
                },
            ], AddNewButtonComponents: [UserModalButtons_1.UserAddNewModalButton], EditButtonComponent: StaffMemberModalButtons_1.StaffMemberEditModalButton, isDeletable: false, repository: StaffMembersController_1.staffMembersRepository, searchOnMount: true })));
}
